export default function todaysDate (state) {
  return state.today.date
}
